// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".discord-dialog .hidden{display:none!important}.discord-dialog .connected-image{position:relative;display:flex;justify-content:center}.discord-dialog .connected-image .profile-image{position:absolute;top:50%;transform:translateY(-50%);border-radius:50px;width:25%;border:3px solid #7289da;background-color:#7289da}.discord-dialog .error{padding:5px}", ""]);
// Exports
module.exports = exports;
